import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environmentFlag } from './utils/systemEnums';
import { AuthServiceLocal } from 'src/@order/services/auth.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { DeviceIdService } from 'src/@order/services/device-id.service';
import { PushNotificationService } from 'src/@order/services/push-notification.service';
import { ProgressBarComponent } from 'src/@order/components/progress-bar/progress-bar.component';
import { PushNotificationBannerComponent } from 'src/@order/components/push-notification-banner/push-notification-banner.component';
import { TrackingService } from 'src/@order/services/tracking.service';
declare global {
  interface Window {
    dataLayer: any[];
  }

  var fbq: any;
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    RouterOutlet,
    ProgressBarComponent,
    PushNotificationBannerComponent,
  ],
})
export class AppComponent implements OnInit {
  private deviceIdService = inject(DeviceIdService);
  private _auth = inject(AuthServiceLocal);
  private deviceService = inject(DeviceDetectorService);
  private pushNotificationService = inject(PushNotificationService);
  private trackingService = inject(TrackingService);

  deviceInfo = null;
  deviceId: string = '';

  constructor() {
    if (!this._auth.api_version) {
      this._auth.getApiVersion();
    }

    this.epicFunction();
    this.trackingService.captureClickIds(); // gclid/fbclid only exist on the landing URL

    console.log(environmentFlag, 'ready UPDATED ON 13-05-2026');
    this.deviceId = this.deviceIdService.getDeviceId();
    if (environmentFlag == 'prod') {
      console.log = function () {};
      console.error = function () {};
      console.warn = function () {};
      console.info = function () {};
    }

    this.setupGlobalErrorHandler();
  }

  private setupGlobalErrorHandler() {
    // Handle unhandled promise rejections (like Google Maps errors)
    window.addEventListener('unhandledrejection', (event) => {
      if (
        event.reason?.message?.includes('vI') ||
        event.reason?.message?.includes('Google Maps') ||
        event.reason?.message?.includes('loading=async') ||
        event.reason?.stack?.includes('maps.googleapis.com')
      ) {
        console.warn('Google Maps related error (suppressed):', event.reason);
        event.preventDefault(); // Prevent the error from appearing in console
        return;
      }
    });

    // Handle general errors
    window.addEventListener('error', (event) => {
      if (
        event.error?.message?.includes('vI') ||
        event.error?.message?.includes('Google Maps') ||
        event.error?.message?.includes('loading=async') ||
        event.filename?.includes('maps.googleapis.com')
      ) {
        console.warn('Google Maps related error (suppressed):', event.error);
        event.preventDefault(); // Prevent the error from appearing in console
        return;
      }
    });
  }

  ngOnInit() {
    console.log('26-08-2025');
    this.pushNotificationService.initializeWebPush();

    // console.log("swUpdate", this.swUpdate);
    // if (this.swUpdate.isEnabled) {
    //   // Check for updates when app initializes
    //   this.swUpdate.checkForUpdate();

    //   // Subscribe to available updates
    //   this.swUpdate.versionUpdates.subscribe(event => {

    //     console.log("swUpdate event", event);
    //     if (event.type === 'VERSION_READY') {
    //       console.log('New version available:', event.latestVersion);

    //       const dialog = this._matDialog.open(AutoUpdateDialogComponent, {
    //         backdropClass: "dialogBackdrop",
    //         width: "450px",
    //         disableClose: true,
    //         data: {
    //           heading: "Force Update.",
    //           content: "New version available. Load new version?",
    //           actionText: "Update App Now",
    //         },
    //       }
    //       ).afterClosed().subscribe(() => {
    //         this.swUpdate.activateUpdate().then(() => {
    //           window.location.reload();
    //         });
    //         // window.location.reload();
    //       });

    //       // // You can prompt the user to refresh

    //     }
    //   });

    //   // // You can also periodically check for updates
    //   setInterval(() => {
    //     this.swUpdate.checkForUpdate();
    //   }, 2 * 60 * 1000); // Check

    // }

    // // Check if Service Worker is registered, if not, register it
    // // This setInterval runs every 2 minutes and can cause issues
    // setInterval(() => {
    //   if (!navigator.serviceWorker.controller) {
    //     console.log('Service Worker not registered, registering now...');
    //     navigator.serviceWorker.register('/ngsw-worker.js').then(registration => {
    //       console.log('Service Worker registered successfully:', registration);
    //     }).catch(err => {
    //       console.error('Service Worker registration failed:', err);
    //     });
    //   } else {
    //     console.log('Service Worker already registered.');
    //   }
    // }, 2 * 60 * 1000); // Check every 2 minutes
  }

  epicFunction() {
    console.log('hello `Home` component ');
    this.deviceInfo = this.deviceService.getDeviceInfo();
    const isMobile = this.deviceService.isMobile();
    const isTablet = this.deviceService.isTablet();
    const isDesktopDevice = this.deviceService.isDesktop();
    console.log('deviceInfo', this.deviceInfo);
    console.log('isMobile', isMobile); // returns if the device is a mobile device (android / iPhone / windows-phone etc)
    console.log('isTablet', isTablet); // returns if the device us a tablet (iPad etc)
    console.log('isDesktopDevice', isDesktopDevice); // returns if the app is running on a Desktop browser.
  }
}
